import {Injectable} from '@angular/core';
import {Response, Headers, URLSearchParams, RequestOptions} from '@angular/http';
import {HttpAuth} from './http-auth.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import 'rxjs/add/operator/map';
import { Invite } from '../models/invite';

@Injectable()
export class InviteService {

  private inviteUrl: string = `${ environment.apiRoot }/invite/`;

  constructor(private http: HttpAuth) { }

  public getInvites(page?:number, pagecount?: number): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    if (page != null) {
      params.append('page', String(page));
    } else {
      params.append('page', '1');
    }

    if (pagecount != null) {
      params.append('pagecount', String(pagecount));
    } else {
      params.append('pagecount', '10');
    }

    const options = new RequestOptions({search: params});

    return this.http.get(this.inviteUrl, options)
      .map(this.extractData)
      .catch((error:any) => Observable.throw(error.json().meta || {message:'Parece que hay problemas con la red o con tu conexión de internet', status:0}));
  }

  public getInviteByJob(jobId: string, page?:number, pagecount?: number, applied?: number): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    params.append('job_id', String(jobId));

    if (page != null) {
      params.append('page', String(page));
    } else {
      params.append('page', '1');
    }

    if (pagecount != null) {
      params.append('pagecount', String(pagecount));
    } else {
      params.append('pagecount', '10');
    }

    if (applied != null) {
      params.append('applied', String(applied));
    }

    const options = new RequestOptions({search: params});

    return this.http.get(this.inviteUrl, options)
      .map(this.extractData)
      .catch((error:any) => Observable.throw(error.json().meta || {message:'Parece que hay problemas con la red o con tu conexión de internet', status:0}));
  }

  public getInvite(id: string): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    params.append('id', String(id));

    const options = new RequestOptions({search: params});

    return this.http.get(this.inviteUrl, options)
      .map(this.extractData)
      .catch((error:any) => Observable.throw(error.json().meta || {message:'Parece que hay problemas con la red o con tu conexión de internet', status:0}));
  }

  public postInvite(listInvitation:any): Observable<Invite> {
    let params: URLSearchParams = new URLSearchParams();
    const body = {invitations: listInvitation};

    let options = new RequestOptions({search: params});

    return this.http.post(this.inviteUrl,body,options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public postReInvite(listInvitation:any, reinvite: boolean): Observable<Invite> {
    let params: URLSearchParams = new URLSearchParams();
    const body = {invitations: listInvitation, reinvite: reinvite};

    let options = new RequestOptions({search: params});

    return this.http.post(this.inviteUrl,body,options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  //noinspection JSMethodCanBeStatic
  private extractData(res: Response) {
    const body = res.json();

    return body.data || {};
  }

  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/services/invite.service.ts